import { requestGet, requestPost, requestPut, requestDelete } from '../request'
import axios from 'axios'
import apiPath from './apiPath'

const api = {
  CreateMenuItemLimit(payload) {
    return requestPost(apiPath.MENU_ITEM_LIMIT.path, payload)
  },

  GetOneMenuItemLimit(menuItemLimitID) {
    return requestGet(`${apiPath.MENU_ITEM_LIMIT.path}/${menuItemLimitID}`)
  },

  GetAllMenuItemLimit(paging, sorting, filtering) {
    return requestGet(apiPath.MENU_ITEM_LIMIT.path, {
      page: paging.page,
      size: paging.size,
      sortBy: sorting.byField,
      sortDir: sorting.isDesc ? 'asc' : 'desc',
      f_outletCode: filtering.outletCode,
      f_menuItemCode: filtering.menuItemCode,
      f_orderType: filtering.orderType
    })
  },

  UpdateMenuItemLimit(menuItemLimitID, payload) {
    return requestPut(
      `${apiPath.MENU_ITEM_LIMIT.path}/${menuItemLimitID}`,
      payload
    )
  },

  DeleteMenuItemLimit(menuItemLimitID) {
    return requestDelete(`${apiPath.MENU_ITEM_LIMIT.path}/${menuItemLimitID}`)
  },

  CreateLimitForNewInterface(payload) {
    return axios({
      url: `${process.env.VUE_APP_QRAVED_APP_URL}/${
        apiPath.ORDERING_ORDER_BO_ASSET_BINDING_MENU_ITEMS_LINK_ORDER_TYPES.path
      }`,
      data: payload,
      method: 'post'
    })
  },

  UpdateLimitForNewInterface(payload) {
    return axios({
      url: `${process.env.VUE_APP_QRAVED_APP_URL}/${
        apiPath.ORDERING_ORDER_BO_ASSET_BINDING_MENU_ITEMS_LINK_ORDER_TYPES.path
      }`,
      data: payload,
      method: 'PATCH'
    })
  },

  GetAllLimitForNewInterface(paging, sorting, filtering) {
    return axios({
      url: `${process.env.VUE_APP_QRAVED_APP_URL}/${
        apiPath.ORDERING_ORDER_BO_ASSET_BINDING_MENU_ITEMS_LINK_ORDER_TYPES.path
      }`,
      method: 'get',
      params: {
        sortby: sorting.byField,
        order: sorting.isDesc ? 'desc' : 'asc',
        page_index: paging.page,
        page_size: paging.size,
        asset_id: filtering.asset_id,
        value: filtering.value,
        f_outletCode: filtering.f_outletCode
      }
    })
  },

  DeleteLimitForNewInterface(payload) {
    return axios({
      url: `${process.env.VUE_APP_QRAVED_APP_URL}/${
        apiPath.ORDERING_ORDER_BO_ASSET_BINDING_MENU_ITEMS_LINK_ORDER_TYPES.path
      }`,
      method: 'delete',
      data: payload
    })
  }
}

export default api
